import { OrderProductKind } from "../common/order-product-kind";

export class OrderItemDTO {
	public id?: number;
	public offerId?: string;
	public offerName?: string;
	public offerUrl?: string;
	public positionId: number;
	public name: string;
	public sku: string;
	public unitExternalId: string;
	public quantity: number;
	public netPrice: number;
	public grossPrice: number;
	public netValue: number;
	public grossValue: number;
	public taxExternalId: string;
	public unitWidth: number;
	public unitHeight: number;
	public unitLength: number;
	public unitWeight: number;
	public kind: OrderProductKind;
	public image: string;
	public commission: number;

	public productId: string | null;
	public inventoryControl?: boolean;
	public symbol?: string;
}

